import { Controller } from 'stimulus'

// A toggle that shows a field only while it's on, e.g. an access link's
// expiry date. Turning it off empties the field, so saving clears it, and
// turning it back on restores what was there.
//   <div data-controller="reveal">
//     <input type="checkbox" data-reveal-target="toggle" data-action="reveal#toggle">
//     <div data-reveal-target="panel">...</div>
export default class extends Controller {
  static targets = ['toggle', 'panel']

  connect() {
    this.toggle()
  }

  toggle() {
    const on = this.toggleTarget.checked
    this.panelTarget.hidden = !on
    // Named fields only: the date picker adds its own (unsubmitted) inputs
    this.panelTarget.querySelectorAll('input[name]').forEach(input => {
      if (on) {
        if (input.dataset.revealValue !== undefined) input.value = input.dataset.revealValue
        input.required = true
      } else {
        input.dataset.revealValue = input.value
        input.value = ''
        input.required = false
      }
    })
  }
}
